import React from 'react'

const ColoredText = ({ text }) => {
    return (
        <span className="text-colored"><strong>{text}</strong></span>
    )
}

export default ColoredText;